/**
 * A number as a plain decimal string with exactly `digits` fraction digits — for
 * SVG coordinates and sizes, never for money.
 *
 * `Number.prototype.toFixed` is banned outside `parseMoney.ts` by
 * `test/moneyFloatGuard.test.ts`: on an amount it is the float round-trip the
 * guard exists to stop, and the guard cannot tell a coordinate from an amount.
 * This is the same output through `Intl`, so a chart coordinate has somewhere
 * to go that is not an exemption. It is not a way round the ban: the guard flags
 * a call to this fed an identifier ending in amount or balance, too.
 */
const cache = new Map<number, Intl.NumberFormat>()

export function fixedDecimals(n: number, digits: number): string {
  let f = cache.get(digits)
  if (!f) {
    f = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
      useGrouping: false,
    })
    cache.set(digits, f)
  }
  return f.format(n)
}
